import { render } from "./DevelopmentInfo.vue?vue&type=template&id=57b2d1be"
import script from "./DevelopmentInfo.vue?vue&type=script&lang=js"
export * from "./DevelopmentInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gokaysen/Desktop/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__